import {AuthApi} from './AuthApi';
import {CredentialApi} from './CredentialApi';

export const authApi = new AuthApi();
export const credentialApi = new CredentialApi();
